import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-edit-folder',
  templateUrl: './edit-folder.component.html',
  styleUrls: ['./edit-folder.component.css']
})
export class EditFolderComponent implements OnInit {

  constructor(private folderService: ServiceService, private route: ActivatedRoute, private router: Router) { }

  Folder_Id = ""
  output: any = [];
  parent: any = [];


  SubFolder: any = [];
  CardShown = false;
  SubName = "*"
  sub_data = {
    shansapp_folder_id: "",
    sub_folder_name: ""
  }
  update: any = {
    _id: "",
    folder_name: ""
  }
  update_sub: any = {
    _id: "",
    sub_folder_name: ""
  }
  FolderDetail: any = {
    _id: "",
    folder_name: "",
    folder_code:"",
    // parent_folder_id:null,
    // parent_folder_name: "",
    // parent_folder_code: "",
    // relative_folder: Array()
  }
  msg1 = ""
  FolderName = "*"
  btnstate = false
  loaderShown = false;
  EditSubId = ""
  EditSubName = ""
  Rel = {
    rel_folder: ""
  }
  selectedItems: any = [];
  dropdownList: any = [];

  dropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true
  };


  //--------function for show card subcategory-----------
  shown() {
    this.CardShown = !this.CardShown;
    this.sub_data.sub_folder_name = " "
    this.msg1 = ""
  }
  //-------fiunction for add subcategory-------------
  Add() {
    if (this.sub_data.sub_folder_name == ' ') {
      this.SubName = "give a name for the sub folder"
      return
    }

    console.log("sub cat=", this.sub_data)
    this.sub_data.shansapp_folder_id = this.Folder_Id;
    this.loaderShown = true;
    //----call api for sub category creation------

    this.folderService.CreateSubFolder(this.sub_data).subscribe((res) => {
      console.log("response=", res.message);

      this.ngOnInit();
      this.loaderShown = false;

    })
    this.CardShown = false;

  }
  //---------check value changes in the text box sub category----
  valuechange2(newValue1: any) {
    console.log("call functio value change2")
    this.sub_data.sub_folder_name = newValue1
    this.SubName = "*"
  }
  //---------check value changes in the text box sub category----
  valuechange1(newValue1: any) {
    this.msg1 = ""
    this.FolderName = "*"
  }
  //-----function for delete sub category--------
  DeleteSub(Id: any) {
    console.log("sub category id=", Id);

    //----call api for delete sub category ------
    this.loaderShown = true;
    this.folderService.DeleteSubFolder(Id).subscribe((res) => {
      console.log("response=", res.message);

      this.ngOnInit();
      this.loaderShown = false;
    })

  }
  //--------function for edit subcategory---------------
  EditSub(Id: any, name: any) {
    this.EditSubId = Id
    this.EditSubName = name
    this.update_sub.sub_folder_name = ""
  }
  //-----------function for update category-------------
  SubmitUpdate() {

    this.setRelatedFolder();
    if (this.FolderDetail.folder_name == "") {
      this.FolderName = "Enter a folder name"
      return;
    }
    this.btnstate = true;

    console.log("data for updation", this.FolderDetail);
    //----call api for update category ------
    this.folderService.UpdateFolder(this.FolderDetail).subscribe((res) => {
      this.msg1 = res.message;
      this.btnstate = false;
      this.router.navigate(['/admin/folder']);

    })
  }
//------function for set final relative folders-------
  setRelatedFolder(){
   
    if(this.selectedItems.length!=0){
      this.FolderDetail.relative_folder=[];
      for(var i=0;i<this.selectedItems.length;i++){
        var obj={
          product_folder_id:this.selectedItems[i].item_id,
          product_folder_name:this.selectedItems[i].item_text
        }
        this.FolderDetail.relative_folder.push(obj)
      }
    }
    this.FolderDetail.folder_code=this.FolderDetail.folder_name
  }
  //------function for update sub category-----------
  // UpdateSubFolder() {

  //   if (this.update_sub.sub_folder_name == "") {
  //     console.log("null")
  //     return;
  //   }
  //   this.update_sub._id = this.EditSubId;
  //   this.loaderShown = true;
  //   console.log("update body=", this.update_sub);

  //   //-----call api for update sub category------------

  //   this.folderService.EditSubFolder(this.update_sub).subscribe((res) => {
  //     console.log("response=", res.message);
  //     this.ngOnInit();
  //     this.loaderShown = false;
  //   })

  // }


  //---function for select folder name-------
  SelectFolder(value: any) {
    this.folderService.GetFolderEach(value).subscribe((res) => {

      this.FolderDetail.parent_folder_id = res.data[0]._id;
      this.FolderDetail.parent_folder_code = res.data[0].folder_code;
      this.FolderDetail.parent_folder_name = res.data[0].folder_name;
    })
  }

  onSelectAll(items: any) {
    // console.log(items);
    this.selectedItems = items
    // console.log("All Item selected",this.selectedItems);
    // this.SetQuotationDetails1()
    // this.msg1=""
  }

  //------function for set initial relative folders-------
  setInitialRelatedFolder(array:any){
    console.log("array=",array)
      this.selectedItems=[];
      for(var i=0;i<array.length;i++){
        var obj={
          item_id :array[i].product_folder_id,
          item_text :array[i].product_folder_name
        }
        this.selectedItems.push(obj)
      }
   console.log("selected items=",this.selectedItems)
  }
 
  ngOnInit(): void {
    this.Folder_Id = this.folderService.GetFolderId();
    //----Api for get folder detail-----------------
    this.folderService.GetFolderEach(this.Folder_Id).subscribe((res) => {
      this.output = res.data
      console.log("folders final=", this.output)
      this.FolderDetail.folder_name = this.output[0].folder_name;
      this.SubFolder = this.output[0]?.shansapp_sub_folder
      this.FolderDetail._id = this.Folder_Id;
      this.setInitialRelatedFolder( this.output[0].relative_folder)
      //-----------------
      this.Rel.rel_folder = this.output[0].relative_folder_name
      //-----------------
    })
    this.folderService.GetFolderDropdown().subscribe((res) => {
      this.parent = res.data
    })

    //----api for folder drop down-----
    this.folderService.GetProductFolder().subscribe((res) => {
      this.dropdownList = []
      for (var i = 0; i < res.data.length; i++) {
        this.dropdownList.push({ item_id: res.data[i].folder_id, item_text: res.data[i].folder_name });
      }
      
    })

  }

}
